export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/constants/general-regex.ts"